import { render, staticRenderFns } from "./assetInvoice.vue?vue&type=template&id=50a705cb&scoped=true"
import script from "./assetInvoice.vue?vue&type=script&lang=js"
export * from "./assetInvoice.vue?vue&type=script&lang=js"
import style0 from "./assetInvoice.vue?vue&type=style&index=0&id=50a705cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a705cb",
  null
  
)

export default component.exports